// Candidate media is optional public presentation; it never supplies a vote identity or quota.
function mediaURL(value) {
  if (typeof value !== 'string' || !value.trim() || /[\\\u0000-\u0020]/.test(value)) return '';
  try {
    const relative = /^\/(?!\/)/.test(value);
    const url = new URL(value, relative ? 'https://local.invalid' : undefined);
    return /^https?:$/.test(url.protocol) && !url.username && !url.password ? (relative ? value : url.href) : '';
  } catch { return ''; }
}

// Both member state and guest preview use the same normalized, candidate-owned presentation.
export function normalizeVoteCandidateDetails(value) {
  if (!value || typeof value !== 'object' || Array.isArray(value)) return null;
  const html = typeof value.html === 'string' ? value.html : '';
  const videos = (Array.isArray(value.videos) ? value.videos : []).filter(row => row && typeof row === 'object').map((row, index) => ({
    title: typeof row.title === 'string' ? row.title : '',
    subTitle: typeof row.subTitle === 'string' ? row.subTitle : '',
    videoName: typeof row.videoName === 'string' ? row.videoName : '',
    videoUrl: mediaURL(row.videoUrl), videoCoverUrl: mediaURL(row.videoCoverUrl),
    sortNo: Number.isSafeInteger(row.sortNo) ? row.sortNo : index + 1
  })).sort((a, b) => a.sortNo - b.sortNo);
  return html.trim() || videos.length ? { html, videos } : null;
}

// Match the server's original key, never candidate name or current ranking position.
export function attachVoteCandidateDetails(base, configured) {
  const source = Array.isArray(configured) ? configured : [];
  return { ...base, candidates: base.candidates.map(candidate => {
    const details = normalizeVoteCandidateDetails(source.find(row => row.key === candidate.id)?.details);
    return details ? { ...candidate, details } : candidate;
  }) };
}

// 在消毒后的HTML上判空，空段落/换行不构成详情，图片介绍仍可独立展示。
export function hasVoteCandidateBody(html) {
  return typeof html === 'string' && (/<(?:img|video|audio)\b/i.test(html) || Boolean(html.replace(/<[^>]*>/g, '').replace(/&nbsp;|&#(?:160|x0*a0);/gi, ' ').trim()));
}
